import { render, staticRenderFns } from "./CharityDonationListView.vue?vue&type=template&id=bc24e200&scoped=true"
import script from "./CharityDonationListView.vue?vue&type=script&lang=js"
export * from "./CharityDonationListView.vue?vue&type=script&lang=js"
import style0 from "./CharityDonationListView.vue?vue&type=style&index=0&id=bc24e200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc24e200",
  null
  
)

export default component.exports